import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, IMenuTranslation, IDefaultLanguage, IUpdateComboGroup } from 'types';

export type TEditComboGroupVisibleForm = 'mainForm' | 'translations';
export type TTypeOfEditComboGroupModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';
export interface IInitialFormData {
	selectedCustomer: Nullable<string>;
	selectedRestaurants: string[];
	selectedDishes: string[];
	name: string;
	selectedComboItems: string[];
	upperLimit: string;
	lowerLimit: string;
	translations: IMenuTranslation[];
}

export interface IEditComboGroupState {
	needRefetchData: boolean;
	initialFormData: IInitialFormData | null;
	visibleForm: TEditComboGroupVisibleForm;
	comboGroupId: string;
	selectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	selectedRestaurants: string[];
	fetchedDishes: IItemForGetShortInfo[];
	selectedDishes: string[];
	name: string;
	fetchedComboItems: IItemForGetShortInfo[];
	selectedComboItems: string[];
	upperLimit: string;
	lowerLimit: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IMenuTranslation[];
	dataForSubmit: IUpdateComboGroup | null;
	typeOfModalWindow: TTypeOfEditComboGroupModalWindow;
}

export const editComboGroupInitialState: IEditComboGroupState = {
	needRefetchData: false,
	initialFormData: null,
	visibleForm: 'mainForm',
	comboGroupId: '',
	selectedCustomer: null,
	fetchedRestaurants: [],
	selectedRestaurants: [],
	fetchedDishes: [],
	selectedDishes: [],
	name: '',
	fetchedComboItems: [],
	selectedComboItems: [],
	upperLimit: '',
	lowerLimit: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditComboGroupContext extends IEditComboGroupState {
	refetchData(value: boolean): void;
	changeVisibleForm(value: TEditComboGroupVisibleForm): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setRestaurants(value: string[]): void;
	setFetchedDishes(value: IItemForGetShortInfo[]): void;
	setDishes(value: string[]): void;
	changeName(value: string): void;
	setFetchedComboItems(value: IItemForGetShortInfo[]): void;
	setComboItems(value: string[]): void;
	updateComboItems(value: IItemForGetShortInfo[]): void;
	changeUpperLimit(value: string): void;
	changeLowerLimit(value: string): void;
	setDefaultCustomerLanguage(value: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(value: IUpdateComboGroup | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditComboGroupModalWindow): void;
	resetFields(): void;
}

export const EditComboGroupContext = createContext<IEditComboGroupContext>({
	refetchData: () => undefined,
	changeVisibleForm: () => undefined,
	setFetchedRestaurants: () => undefined,
	setRestaurants: () => undefined,
	setFetchedDishes: () => undefined,
	setDishes: () => undefined,
	changeName: () => undefined,
	setFetchedComboItems: () => undefined,
	setComboItems: () => undefined,
	updateComboItems: () => undefined,
	changeUpperLimit: () => undefined,
	changeLowerLimit: () => undefined,
	setDefaultCustomerLanguage: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...editComboGroupInitialState,
});
